import Shift from './shift'
import {date} from '@eitje/utils'

class CheckIn extends Shift {
	static tableName = 'checkIns'
	static defaultJoins = ['users', 'teams']

	constructor(props) {
		super(props)
		if (this.shift_ids) this.time_registration_shift_ids = this.shift_ids
	}

	_endDate = () => this.end_date || date()

	hasEndTime() {
		return !!this.end_date
	}

	durationString(options) {
		if (!this.hasEndTime()) return `${this.startTime()} - ...`
		return super.durationString(options)
	}
}

export default CheckIn
